import React from "react";
import { CheckOutlined } from "@ant-design/icons";

export const LuxuryCheckbox = ({ 
  id, 
  label = "Mail Access", 
  checked = false, 
  onChange,
  disabled
}) => {
  return (
    <div
      onClick={() => onChange && !disabled && onChange(!checked)}
       disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        cursor: "pointer",
        padding: "6px 8px",
        border: "1.5px solid",
        borderColor: checked ? "#22c55e" : "#efefef",
        borderRadius: "10px",
        background: checked
          ? "linear-gradient(135deg, rgba(34, 197, 94, 0.02) 0%, rgba(34, 197, 94, 0.04) 100%)"
          : "#ffffff",
        transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
        boxShadow: checked
          ? "0 4px 12px rgba(34, 197, 94, 0.08), inset 0 1px 0 rgba(34, 197, 94, 0.04)"
          : "0 2px 4px rgba(0, 0, 0, 0.02)",
        userSelect: "none",
        width: "100%",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "#d0d0d0";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.06)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = checked ? "#1a1a1a" : "#efefef";
        e.currentTarget.style.boxShadow = checked
          ? "0 4px 12px rgba(26, 26, 26, 0.08), inset 0 1px 0 rgba(26, 26, 26, 0.04)"
          : "0 2px 4px rgba(0, 0, 0, 0.02)";
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          borderRadius: "8px",
          border: "1.5px solid",
          borderColor: checked ? "#1a1a1a" : "#d0d0d0",
          background: checked
            ? "linear-gradient(135deg, #1a1a1a 0%, #333333 100%)"
            : "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
          boxShadow: checked
            ? "0 2px 6px rgba(26, 26, 26, 0.12), inset 0 1px 0 rgba(255,255,255,0.1)"
            : "none",
          flexShrink: 0,
        }}
      >
        {checked && (
          <CheckOutlined
            style={{
              color: "#ffffff",
              fontSize: "12px",
              fontWeight: "700",
            }}
          />
        )}
      </div>

      <span
        style={{
          fontWeight: "600",
          color: checked ? "#1a1a1a" : "#666",
          fontSize: "13px",
          letterSpacing: "-0.01em",
          transition: "all 0.3s ease",
        }}
      >
        {label}
      </span>
    </div>
  );
};

export default LuxuryCheckbox;